import { ApolloError } from '@apollo/client';
import { Card } from '@mui/material';

import { LoadedContent } from '@occc-app/design-system';
import { SiteConnectionHistorySummary } from '@occc/graphql';

import { LocationConnectionHistorySummaryItem } from './connection-history-summary-item.component';

type LocationConnectionHistorySummaryProps = {
  data?: SiteConnectionHistorySummary | null;
  error?: ApolloError;
  loading: boolean;
};

type SummaryDataItem = {
  value: number;
  label: string;
  color: string;
};

export const LocationConnectionHistorySummary = ({
  data,
  error,
  loading,
}: LocationConnectionHistorySummaryProps) => {
  const getItems = (): SummaryDataItem[] | null => {
    if (data) {
      return [
        {
          value: data.totalConnections,
          label: 'Connections',
          color: 'success.light',
        },
        {
          value: data.totalDisconnections,
          label: 'Disconnections',
          color: 'error',
        },

        {
          value: data.totalConnectionFailures,
          label: 'Connection Failures',
          color: 'error',
        },
      ];
    }

    return null;
  };

  const renderData = () => (
    <>
      {getItems()?.map(({ value, label, color }, index) => (
        <LocationConnectionHistorySummaryItem
          key={index}
          value={value}
          label={label}
          color={color}
        />
      ))}
    </>
  );

  return (
    <Card
      sx={{
        py: 3,
        px: 0,
        mb: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LoadedContent<SummaryDataItem>
        loading={loading}
        error={error}
        items={getItems()}
        renderData={renderData}
      />
    </Card>
  );
};
